export default "__VITE_ASSET__ad462fe5__"